import React, {ReactNode} from 'react';
import './collapsible-area.scss';

interface Props {
  content: ReactNode;
  isDefaultOpen: boolean;
  summary: ReactNode;
}

export default function CollapsibleArea({content, isDefaultOpen, summary}: Props) {
  return (
    <details className='collapsible-area' open={isDefaultOpen}>
      <summary className='collapsible-area__summary'>{summary}</summary>
      {content}
    </details>
  );
}
